// The backend stores line item position as a byte (0-255). New items are capped
// at that range, while overflow rows on existing jobs retain the legacy null fallback.
export const MAX_LINE_ITEM_POSITION = 255
export const MAX_POSITIONED_LINE_ITEMS = MAX_LINE_ITEM_POSITION + 1

export function canAddPositionedLineItem(lineItemCount: number) {
  return lineItemCount < MAX_POSITIONED_LINE_ITEMS
}

export function getPersistedLineItemPosition(index: number) {
  return index >= 0 && index <= MAX_LINE_ITEM_POSITION ? index : null
}
